import { lazy } from 'react';
import { PERMISSION_MONITOR, ROLE_NOC } from 'Constants';

export default {
  ui: 'menuLeft',
  auth: { role: PERMISSION_MONITOR },
  path: 'monitoring',
  urlParams: '/:type?/:view?/:subview?',
  title: 'Monitoring',
  component: lazy(() => import('./index')),
  children: [
    {
      path: '/active',
      component: () => null,
      hasViewGrid: true,
      title: 'Active Channels',
      pageTitle: 'Monitoring Active Channels'
    },
    {
      path: '/my-channels',
      component: () => null,
      hasViewGrid: true,
      title: 'My Channels',
      pageTitle: 'Monitoring My Channels'
    },
    {
      path: '/all',
      component: () => null,
      hasViewGrid: true,
      title: 'All Channels',
      pageTitle: 'Monitoring All Channels'
    },
    {
      path: '/sites',
      component: () => null,
      title: 'Sites',
      pageTitle: 'Monitoring Sites'
    },
    {
      path: '/connector-leaves',
      component: () => null,
      title: 'Active Connector Leaves',
      pageTitle: 'Active Connector Leaves'
    },
    {
      path: '/notifications',
      component: () => null,
      title: 'Notifications',
      pageTitle: 'Notifications'
    },
    {
      path: '/alarm-history',
      urlParams: '/:channel?',
      component: () => null,
      title: 'Alarm History',
      pageTitle: 'Alarm History',
      auth: { role: ROLE_NOC },
    },
  ],
};
